import { useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Empathy from "@/pages/home/components/Empathy";
import Recommend from "@/pages/home/components/Recommend";
import Changes from "@/pages/home/components/Changes";
import Features from "@/pages/home/components/Features";
import Materials from "@/pages/home/components/Materials";
import Curriculum from "@/pages/home/components/Curriculum";
import CourseInfo from "@/pages/home/components/CourseInfo";
import CTA from "@/pages/home/components/CTA";
import Footer from "@/pages/home/components/Footer";
import ApplyModal from "@/pages/home/components/ApplyModal";
import JsonLd from "@/components/feature/JsonLd";
import useDeadlineOverride from "@/hooks/useDeadlineOverride";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  "name": "실전 일본어 연구소",
  "description": "왕초보 일본어 8주 실전 기초반. 애니, 드라마, 여행에서 바로 쓰는 일본어를 최대 5명 소수정예 온라인 수업으로 배워보세요.",
  "url": siteUrl,
  "email": "siljeon.jp@gmail.com",
  "sameAs": [
    "https://www.instagram.com/siljeon.jp_lab",
    "http://pf.kakao.com/_VxdxgxnX"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "email": "siljeon.jp@gmail.com",
    "contactType": "customer service"
  }
};

export default function Home() {
  const [applyOpen, setApplyOpen] = useState(false);
  const { isManuallyClosed } = useDeadlineOverride();

  const openApply = () => {
    if (isManuallyClosed) return;
    setApplyOpen(true);
  };
  const closeApply = () => setApplyOpen(false);

  return (
    <div className="min-w-0 bg-background-50 text-foreground-950 font-body">
      <JsonLd data={organizationSchema} />
      <Navbar onApply={openApply} isManuallyClosed={isManuallyClosed} />
      <main>
        <Hero onApply={openApply} isManuallyClosed={isManuallyClosed} />
        <Empathy />
        <Recommend />
        <Changes />
        <Features />
        <Materials />
        <Curriculum />
        <CourseInfo />
        <CTA onApply={openApply} isManuallyClosed={isManuallyClosed} />
      </main>
      <Footer />
      <ApplyModal open={applyOpen} onClose={closeApply} />
    </div>
  );
}